module.exports = __webpack_public_path__ + "img/sjbg.edeb8ddc.jpg";